import { useDispatch, useSelector } from 'react-redux'
import Button from '../../components/Button'
import { hasCartItems } from '../../selectors/cart'
import { setRoute } from '../../VNRoutes/ActionCreators'
import { startOrderAction } from '../../VNOrders/ActionCreators'
import { VNORDERS_ACTIONS, VNORDERS_FEATURE_ENABLED } from '../../VNOrders/Enums'
import { getVNOrdersActionsParams } from '../../VNOrders/ActionParams'

const PayNowButton = ({ className }) => {
  const dispatch = useDispatch()
  const hasItems = useSelector(hasCartItems)

  const handlePayNow = () => {
    if (VNORDERS_FEATURE_ENABLED) {
      dispatch(startOrderAction(VNORDERS_ACTIONS.START_ORDER, getVNOrdersActionsParams('/tender-selection')))
      return
    }

    dispatch(setRoute('/tender-selection'))
  }

  return (
    <Button className={className} disabled={!hasItems} onClick={handlePayNow}>
      {'Pay Now'}
    </Button>
  )
}

export default PayNowButton
